import { Component, OnInit } from '@angular/core';
import { DataSource } from '@angular/cdk/table';
import { AccountService } from 'src/app/services/account.service';
import { CollectionViewer } from '@angular/cdk/collections';
import { Observable, BehaviorSubject, of } from 'rxjs';
import { catchError, finalize } from 'rxjs/operators';
import { CommonfilterService } from 'src/app/services/commonfilter.service';
import { trigger, state, style, transition, animate } from '@angular/animations';
import { Router, ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-account-payment-list',
  templateUrl: './account-payment-list.component.html',
  styleUrls: ['./account-payment-list.component.css'],
  // // animations: [
  //   trigger('detailExpand', [
  //     state('collapsed', style({ height: '0px', minHeight: '0', visibility: 'hidden' })),
  //     state('expanded', style({ height: '*', visibility: 'visible' })),
  //     transition('expanded <=> collapsed', animate('225ms cubic-bezier(0.4, 0.0, 0.2, 1)')),
  //   ]),
  // ],
})
export class AccountPaymentListComponent implements OnInit {
  paymentData: any = {};
  payTMVerifiedModel = true;
  payTMModel = true;
  payUVerifiedModel = true;
  payUModel = true;
  selectedIndex = 0;
  collapsed;
  payU_dataSource = new PayUDataSource(this.accountService);

  payTM_dataSource = new PayTMDataSource(this.accountService);
  payudisplayedColumns = ['id', 'businessName', 'accLinkedPhno','payUVerified' ];
  payTMdisplayedColumns = ['id', 'businessName', 'payTmLinkedPhoneNumber', 'payTmVerified' ];
  payuFilterParams: any;
  payUCount: any;
  payTMCount: any;
  payTMFilterParams: string;
  expandedElement: any;
  selectedRowIndex = -1;
  showpayTMBar = false;
  showpayuBar = false;
  selected_payu_rowIndex = -1;
  selected_paytm_rowIndex = -1;
  filter: any;
  //isExpansionDetailRow = (i: number, row: Object) => row.hasOwnProperty('detailRow');
 

  constructor(private accountService: AccountService,
     private commonService: CommonfilterService,
     private router: Router,
    private route: ActivatedRoute) { }

  ngOnInit() {
    this.paymentData = this.accountService.getPaymentData();
    this.selectedIndex = this.paymentData.tabindex;
    this.payUModel = this.paymentData.payu;
    this.payUVerifiedModel = this.paymentData.payuVerified;
    this.filter = this.paymentData.filter;
    this.payTMModel = this.paymentData.payTm;
    this.payTMVerifiedModel = this.paymentData.payTmVerified;
    this.payuFilterParams = 'razorpay-eq=' + this.payUModel + '&razorpayVerified-eq=' + this.payUVerifiedModel +this.filter
    + '&';
    this.payTMFilterParams = 'paytm-eq=' + this.payTMModel + '&payTmVerified-eq=' + this.payTMVerifiedModel + this.filter + '&';
    this.getPaymentData();

  }
  getPaymentData(): any {
    this.getPayuTotalCount();
    this.payU_dataSource.loadPayuList( this.payuFilterParams, 'false', 0, 50);
    this.getPayTMTotalCount();
    this.payTM_dataSource.loadPayTMList( this.payTMFilterParams, 'false', 0, 50);
  }
  setPayuFilter() {
    this.payuFilterParams = this.commonService.createfilterParams('payU') + this.filter;
    this.getPaymentData();
  }
  setPayTMFilter() {
    this.payTMFilterParams = this.commonService.createfilterParams('payTM') + this.filter;
    this.getPaymentData();
  }
  getPayuTotalCount() {
    this.accountService.getPaymentCount(this.payuFilterParams)
    .subscribe(
      res => {this.payUCount = res;
      });
  }
  getPayTMTotalCount() {
    this.accountService.getPaymentCount(this.payTMFilterParams)
    .subscribe(
      res => {this.payTMCount = res;
      });
  }
  // onRowClicked(row) {
  //   this.selectedRowIndex = row.accountId;
  //   this.showToolBar = true;
  // }
  onpayURowClicked(row) {
    this.selected_payu_rowIndex = row.accountId;
    this.showpayuBar = true;
  }
  onpayTMRowClicked(row) {
    this.selected_paytm_rowIndex = row.accountId;
    this.showpayTMBar = true;
  }
  // paymenyPayUSettings() {
  //   this.router.navigate(['../../view', this.selected_payu_rowIndex, 'paymentSettings'], { relativeTo: this.route });
  // }
  // paymenyPayTMSettings() {
  //   this.router.navigate(['../../view', this.selected_paytm_rowIndex, 'paymentSettings'], { relativeTo: this.route });
  // }
   paymenyPayUSettings() {
    this.router.navigate(['../../view', this.selected_payu_rowIndex, 'paymentdetails'], { relativeTo: this.route });
  }
  paymenyPayTMSettings() {
    this.router.navigate(['../../view', this.selected_paytm_rowIndex, 'paymentdetails'], { relativeTo: this.route });
  }
}

export class PayUDataSource implements DataSource<any> {
private payUSubject = new BehaviorSubject <any[]> ([]);
private payuloadingSubject = new BehaviorSubject<boolean>(false);
public payuloading$ = this.payuloadingSubject.asObservable();
constructor(private accountService: AccountService) {

}

  connect(collectionViewer: CollectionViewer): Observable<any> {
   return this.payUSubject.asObservable();
  }
  disconnect(collectionViewer: CollectionViewer) {
    this.payUSubject.complete();
    this.payuloadingSubject.complete();

  }
  loadPayuList( filter,
    sortDirection, count, pageSize) {
    this.payuloadingSubject.next(true);
    this.accountService.getPaymentList( filter, sortDirection,
      count, pageSize).pipe(
       catchError(() => of([])),
        finalize(() => this.payuloadingSubject.next(false))
      )
      .subscribe(res => this.payUSubject.next(res));
    }

}

export class PayTMDataSource implements DataSource<any> {
  private payTMSubject = new BehaviorSubject<any[]>([]);
  private payTMloading = new BehaviorSubject<boolean>(false);
  public payTMloading$ = this.payTMloading.asObservable();
  constructor(private accountService: AccountService) {

  }

  connect(collectionViewer: CollectionViewer): Observable<any> {
     return this.payTMSubject.asObservable();
  }

  disconnect(collectionViewer: CollectionViewer) {
   this.payTMSubject.complete();
   this.payTMloading.complete();
  }


  loadPayTMList( filter,
    sortDirection, count, pageSize) {
    this.payTMloading.next(true);
    this.accountService.getPaymentList( filter, sortDirection,
      count, pageSize).pipe(
       catchError(() => of([])),
        finalize(() => this.payTMloading.next(false))
      )
      .subscribe(res => {
        this.payTMSubject.next(res);
      }
        );
    }
}
